import { render, staticRenderFns } from "./DaifaIntegration.vue?vue&type=template&id=4d8267fa&scoped=true"
import script from "./DaifaIntegration.vue?vue&type=script&lang=js"
export * from "./DaifaIntegration.vue?vue&type=script&lang=js"
import style0 from "./DaifaIntegration.vue?vue&type=style&index=0&id=4d8267fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8267fa",
  null
  
)

export default component.exports